import { render, staticRenderFns } from "./GLArtCanvas.vue?vue&type=template&id=6517840a&"
import script from "./GLArtCanvas.vue?vue&type=script&lang=js&"
export * from "./GLArtCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports